<template>
  <v-container>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <v-text-field dense
                  hide-details label="Tax Year" v-model.number="editedItem.taxYear"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="5">
                  <v-select class="input-text-size "
                  :items="taxDistrictListForTifBase"
                  item-text="taxDistrictCodeAndName"
                  item-value="districtCode"
                  label="TIF Base Tax District"
                  dense
                  v-model="editedItem.tifTaxDistrict"
                  @input="handleLoadLavyList()"
                ></v-select>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <v-text-field dense
                  hide-details label="Description"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  v-model="editedItem.description" ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-select class="input-text-size "
                  :items="taxDistrictListForTifDistribution"
                  item-text="taxDistrictCodeAndName"
                  item-value="districtCode"
                  label="TIF Distribution Tax District"
                  dense
                  v-model="editedItem.distributionTaxDistrict"
                ></v-select>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <v-text-field dense
                  hide-details label="City"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  v-model="editedItem.city" ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <v-text-field dense v-model.number="editedItem.baseValue"
                  @input="calculateTragetAmount()"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  hide-details label="Base Value"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field dense v-model.number="editedItem.levy"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  hide-details label="Levy" ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="6">
                  <v-text-field dense v-model.number="editedItem.targetAmount"
                  hide-details label="Target Amount"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field dense v-model.number="editedItem.collections"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  label="Collection"
                  hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="6">
                  <v-text-field dense v-model.number="editedItem.distributions"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  hide-details label="Distribution"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field dense v-model.number="editedItem.overgaeToTif"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  label="% Of Overage to TIF"
                  :rules="[overageToTifRule]"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <v-checkbox
                    id="tifDistrictsEditItemIsPageBreak"
                    class="tif-districts-edit-item-is-page-break"
                    dense
                    hide-details
                    v-model="editedItem.pageBreakBefore"
                    label="Page Break After"
                  >
                  </v-checkbox>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5" class="d-flex align-center justify-end">
                  <v-btn
                    v-if="editedItem._id"
                    id="tifDistrictsCopyToNextYear"
                    class="input-text-size"
                    text
                    color="primary"
                    :loading="isCopying"
                    :disabled="isCopying"
                    @click="copyToNextYear"
                  >Copy to Next Year</v-btn>
                </v-col>
              </v-row>
              <v-row dense v-if="copyWarning">
                <v-col cols="12">
                  <v-alert
                    id="tifDistrictsCopyWarning"
                    type="warning"
                    dense
                    text
                    class="input-text-size"
                  >{{ copyWarning }}</v-alert>
                </v-col>
              </v-row>
  </v-container>
</template>

<script>
import {
  mapActions, mapState,
  mapGetters, mapMutations,
} from 'vuex';
import {
  toFiscalYear,
} from '../../../util/shared/tmc-global';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

// "% of Overage to TIF" is required, 0-100: it decides how much of a TIF's overage moves to the
// distribution district. v-model.number leaves a blank as '' and non-numeric text as a string.
const overageToTifRule = (value) => {
  if (value === '' || value === null || value === undefined) return 'Required (0 - 100)';
  return (typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 100)
    || 'Must be a number from 0 to 100';
};

export default {
  mixins: [GlobalToCaps],
  data() {
    return {
      totalmillsVal: null,
      isCopying: false,
      copyWarning: '',
      overageToTifRule,
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items']),
    ...mapGetters(['todaysDate']),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    taxDistrictListForTifDistribution() {
      const taxDistrictBaseCrudKey = 'sharedTaxDistrict';
      const items = this.items(taxDistrictBaseCrudKey) || [];
      const updatedItem = items.filter((ft) => ft.isTifDistribution).map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
      return [...updatedItem];
    },
    taxDistrictListForTifBase() {
      const taxDistrictBaseCrudKey = 'sharedTaxDistrict';
      const items = this.items(taxDistrictBaseCrudKey) || [];
      const updatedItem = items.filter((ft) => ft.isTifBase).map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
      return [...updatedItem];
    },
    currentFiscalYear() {
      return toFiscalYear(new Date(this.todaysDate));
    },
  },
  watch: {
    'editedItem._id': function clearCopyWarning() {
      this.copyWarning = '';
    },
  },
  methods: {
    ...mapActions('shared/taxLevy', [
      'loadTaxLevy',
    ]),
    ...mapActions('shared/taxUnit', [
      'loadMaxFiscalYear',
    ]),
    ...mapActions('tax/tifDistricts', [
      'upserttifDistrict',
    ]),
    ...mapActions(['flashSuccess']),
    // item defaults to the record on screen; Copy to Next Year passes the new record instead
    calculateTragetAmount(item = this.item(this.baseCrudKey)) {
      const targetAmt = amountFormat((item.baseValue * item.levy) / 1000);
      // eslint-disable-next-line no-param-reassign
      item.targetAmount = amountToNumber(targetAmt);
    },
    ...mapMutations('base/crud', ['setItem']),
    async handleLoadLavyList(item = this.editedItem) {
      const taxDistrictBaseCrudKey = 'sharedTaxDistrict';
      const items = this.items(taxDistrictBaseCrudKey);
      const id = items.filter((el) => el.districtCode === item.tifTaxDistrict);
      const criteria = {
        taxDistrict: id.length ? id[0]._id : null,
        taxYear: item.taxYear,
      };
      const maxFiscalYear = await this.loadMaxFiscalYear() || this.currentFiscalYear;

      if (maxFiscalYear) {
        criteria.fiscalYear = maxFiscalYear;
      }

      if (criteria.taxDistrict && item.taxYear) {
        const res = await this.loadTaxLevy({
          criteria,
        });
        const totalmills = res.reduce((acc, curr) => acc + curr.mills, 0);
        // Adding 2-decimal mill rates leaves float residue (33.33 + 33.33 + 20.29 = 86.94999999999999).
        // 4 decimals keeps real 3-4 decimal rates; the target amount is then worked out from this.
        // eslint-disable-next-line no-param-reassign
        item.levy = Math.round(totalmills * 10000) / 10000 || 0;
      }
    },
    // The next tax year's record: same TIF setup, nothing collected or distributed yet, unlocked.
    // levy/targetAmount start at 0 so a levy that is not on file yet does not carry this year's.
    nextYearTifRecord(source) {
      return {
        taxYear: Number(source.taxYear) + 1,
        tifTaxDistrict: source.tifTaxDistrict,
        distributionTaxDistrict: source.distributionTaxDistrict,
        description: source.description,
        city: source.city,
        baseValue: source.baseValue,
        overgaeToTif: Number.isFinite(source.overgaeToTif) ? source.overgaeToTif : 100,
        pageBreakBefore: source.pageBreakBefore,
        levy: 0,
        targetAmount: 0,
        collections: 0,
        distributions: 0,
        lock: false,
      };
    },
    // Creates a separate record and leaves the one on screen alone. The backend refuses a second
    // record for the same TIF base and tax year; the store flashes its message.
    async copyToNextYear() {
      if (this.isCopying) return;
      this.isCopying = true;
      this.copyWarning = '';
      try {
        const nextYearItem = this.nextYearTifRecord(this.editedItem);
        // new tax year first, then that year's levy, then the target from it
        await this.handleLoadLavyList(nextYearItem);
        this.calculateTragetAmount(nextYearItem);
        const created = await this.upserttifDistrict({
          item: nextYearItem,
          baseCrudKey: this.baseCrudKey,
        });
        if (!created) return;
        const { tifTaxDistrict, taxYear } = nextYearItem;
        if (nextYearItem.levy) {
          this.flashSuccess(`TIF record for ${tifTaxDistrict} copied to tax year ${taxYear}.`);
        } else {
          this.copyWarning = `TIF record for ${tifTaxDistrict} copied to tax year ${taxYear}, but no ${taxYear} levy was found for ${tifTaxDistrict}. Its levy and target amount were saved as 0 - set them once the ${taxYear} levy is certified.`;
        }
      } finally {
        this.isCopying = false;
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  max-width: 600px;
  margin: 0 auto;
}

</style>
